import useApi from "..";

const useAuthApi = () => {
    const { request } = useApi();

    const signIn = (payload) => request('/auth/login', 'POST', payload);
    const signUp = (payload) => request('/auth/signup', 'POST', payload);
    const switchAccountSignup = (payload) => request('/user/switch-profile', 'PUT', payload);
    const socialSignUp = (payload) => request('/auth/social-signup', 'POST', payload);
    const forgotPassword = (payload) => request('/auth/forget-password', 'POST', payload);
    const verifyOtp = (payload) => request('/auth/verify-token', 'POST', payload);
    const resetPassword = (payload) => request('/auth/reset-password', 'POST', payload);
    const logout = () => request('/auth/logout', 'POST', null);


    return { signIn, signUp, forgotPassword, verifyOtp, resetPassword, logout, socialSignUp, switchAccountSignup };
};

export default useAuthApi;
